<template>
    <b-container class="event" v-if="category">
        <b-row>
            <b-col class="event-title-label font-size-100">
                {{category.name}}
            </b-col>
        </b-row>
        <b-row class="mt-4">
            <b-col>
                <PreviewEventList :category-id="categoryId" v-if="category.layout_style === 1"></PreviewEventList>
                <PreviewEventCarousel :category-id="categoryId" v-if="category.layout_style === 2"></PreviewEventCarousel>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import PreviewEventList from "../../../components/PreviewEventList";
    import PreviewEventCarousel from "../../../components/PreviewEventCarousel";

    export default {
        name: 'PreviewEvent',
        components: {PreviewEventCarousel, PreviewEventList},
        data() {
            return {
                categoryId: this.$route.params.categoryId,
                category: null,
            };
        },
        mounted() {
            this.getCategory();
        },
        methods: {
            getCategory() {
                this.$callAPI('hkiarace/event_category/', {category_id: this.categoryId}, function (response) {
                    this.category = response.body.category;
                });
            },

        },
        watch: {
            '$route.params.categoryId'(newVal) {
                this.categoryId = newVal;
                this.getCategory();
                // this.getEvents();
            },
        },
    }
</script>

<style lang="less">
    .event {
        .event-title-label {
            font-weight: bold;
            text-align: left;
        }
    }
</style>
